var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseMode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6568_8057)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6568_8057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1051 14.5004C26.1051 8.09106 20.9093 2.89526 14.4999 2.89526C8.09057 2.89526 2.89478 8.09106 2.89478 14.5004C2.89478 20.9097 8.09057 26.1055 14.4999 26.1055V27.1727C7.50121 27.1727 1.82764 21.4991 1.82764 14.5004C1.82764 7.5017 7.50121 1.82812 14.4999 1.82812C21.4986 1.82812 27.1722 7.5017 27.1722 14.5004C27.1722 21.4991 21.4986 27.1727 14.4999 27.1727V26.1055C20.9093 26.1055 26.1051 20.9097 26.1051 14.5004Z",
    fill: "#32F6DB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6568_8057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6636 21.7768C13.1164 21.7768 13.4849 21.4084 13.4849 20.9555V8.04395C13.4849 7.5911 13.1164 7.22266 12.6636 7.22266H9.87402C9.42118 7.22266 9.05273 7.5911 9.05273 8.04395V20.9555C9.05273 21.4083 9.42118 21.7767 9.87402 21.7767H12.6636V21.7768ZM9.90234 8.07227H12.6353V20.9271H9.90234V8.07227Z",
    fill: "#32F6DB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6568_8057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5225 9.97233C19.7571 9.97233 19.9473 9.78219 19.9473 9.54753V8.04395C19.9473 7.5911 19.5788 7.22266 19.126 7.22266H16.3364C15.8836 7.22266 15.5151 7.5911 15.5151 8.04395V20.9555C15.5151 21.4083 15.8836 21.7767 16.3364 21.7767H19.126C19.5788 21.7767 19.9473 21.4083 19.9473 20.9555V9.34155C19.9473 9.10689 19.7571 8.91674 19.5225 8.91674C19.2879 8.91674 19.0977 9.10689 19.0977 9.34155V20.9271H16.3647V8.07227H19.0977V9.54753C19.0977 9.78219 19.2879 9.97233 19.5225 9.97233Z",
    fill: "#32F6DB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6568_8057",
    x: 0.152081,
    y: 0.152569,
    width: 28.6956,
    height: 28.6949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.837778
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6568_8057",
    x: 7.37718,
    y: 5.5471,
    width: 7.78324,
    height: 17.9058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.837778
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6568_8057",
    x: 13.8396,
    y: 5.5471,
    width: 7.78324,
    height: 17.9058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.837778
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.196078 0 0 0 0 0.964706 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6568_8057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6568_8057",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6568_8057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseMode);
export default __webpack_public_path__ + "static/media/pause-mode.7d6bf626c804eefcf791f109369502da.svg";
export { ForwardRef as ReactComponent };